
import { validationMixin } from "vuelidate";
import { mapGetters } from "vuex";
import { SistemaMixin } from "@/modules/Application";
import ListaProdutoData, { ListaProdutoDataRequired } from "./ListaProdutoData";
import _ from "lodash";
import VueSelect from "vue-select";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import TableApp from "@/components/Table/Table3.vue";
import Plus from "vue-material-design-icons/PlusThick.vue";
import { Money } from "v-money";
import { priceOptions } from "@/modules/Application";
export default {
  name: "app-lista-produto-form",
  props: {
    url: {
      type: String,
    },
    lista: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    VueSelect,
    TableApp,
    TrashCanIcon,
    Plus,
    Money,
  },
  mixins: [validationMixin, SistemaMixin],
  data() {
    return {
      priceOptions,
      keyToRender: 0,
      form: {},
      produtoSelected: {
        descricao: "",
        id_produto: null,
        preco_lista: 0,
      },
      produtosFetched: [],
      windowWidth: window.innerWidth,
      produtosGrupo: [],
      grupos: [],
      produtos: [],
      grupoSelected: null,
      grupoOptions: {
        descricao: "",
        value: 0,
        fator: "acrescimo",
      },
      fields: [
        {
          label: "Item/Cód",
          field: "item",
          slot: true,
          sortable: false,
          width: "5%",
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: "Nome",
          field: "descricao",
          slot: true,
          sortable: false,
          width: "40%",
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: "Preço",
          field: "preco_lista",
          sortable: false,
          slot: true,
          width: "20%",
        },
        {
          label: "",
          field: "actions",
          sortable: false,
          slot: true,
          width: "10%",
        },
      ],
      grupoFields: [
        {
          label: "Cód",
          field: "id",
          slot: true,
          sortable: false,
          width: "5%",
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: "Nome",
          field: "descricao",
          slot: true,
          sortable: false,
          width: "55%",
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: "Preço antigo",
          field: "preco",
          sortable: false,
          slot: true,
          width: "20%",
        },
        {
          label: "Preço",
          field: "preco_lista",
          sortable: false,
          slot: true,
          width: "20%",
        },
      ],
    };
  },
  validations: {
    form: ListaProdutoDataRequired,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  async mounted() {
    this.$root.$emit("bv::show::popover", "ambienteTuto");
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    await this.getDataInit();
  },
  methods: {
    async getDataInit() {
      this.form = new ListaProdutoData({});
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    salvarProdutosGrupo() {
      this.produtos = _.cloneDeep(this.produtosGrupo);
      this.produtosGrupo = [];
      this.$bvModal.hide("modal-busca-grupo");
    },
    async aplicarPrecoParaEstoque() {
      const { value, fator } = this.grupoOptions;

      this.addLoadingToButton("aplicarPrecoParaEstoque");

      try {
        const { data } = await this.$http.post("/produtos/get-produtos", {
          percentual: value,
          fator,
        });

        this.produtos = data;
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("aplicarPrecoParaEstoque");
      (this.grupoOptions = {
        descricao: "",
        value: 0,
        fator: "acrescimo",
      }),
        this.$bvModal.hide("modal-aplicar-para-estoque");
    },
    async salvarLista() {
      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          this.$toast.error(
            "Verifique todos os campos obrigatórios do formulário!"
          );
          return;
        }

        if (this.produtos.length === 0) {
          this.$toast.error("Insira ao menos um produto na lista!");
          return;
        }

        this.addLoadingToButton("submit_nova_lista");

        await this.$http.post(this.url, {
          ...this.form,
          produtos: this.produtos.map((produto) => ({
            ...produto,
          })),
          ...(this?.lista?.id_lista_preco && {
            id_lista_preco: this.lista.id_lista_preco,
          }),
        });
        this.removeLoadingToButton("submit_nova_lista");
        this.$router.push({ name: "lista" });
      } catch (error) {
        this.removeLoadingToButton("submit_nova_lista");
      }
    },
    handleDeleteProduto(index) {
      const aux = _.cloneDeep(this.produtos);
      aux.splice(index, 1);
      this.produtos = [...aux];
    },
    setProduto(produto) {
      if (!produto) return;

      this.produtoSelected = {
        codigo: produto.codigo,
        id: produto.id,
        descricao: produto.descricao,
        preco_lista:
          this.produtoSelected.preco_lista > 0
            ? this.produtoSelected.preco_lista
            : parseFloat(produto.preco),
      };
    },
    onSearchProduto(search, loading) {
      if (search.length > 2 || /^[0-9]+$/.test(search)) {
        loading(true);
        this.searchProdutos(loading, search, this);
      }
    },
    searchProdutos: _.debounce(async (loading, search, vm) => {
      vm.produtosFetched = await vm.fetchProdutos(search, vm.typeFilter);
      loading(false);
    }, 350),
    onSearchGrupo(search, loading) {
      const busca = this.prepararBuscaDireta(search, loading);
      busca.loading(true);
      this.searchGrupo(busca.loading, busca.termo, this);
    },
    searchGrupo: _.debounce(async (loading, search, vm) => {
      vm.grupos = await vm.fetchGrupo(search);
      loading(false);
    }, 350),
    async aplicarPrecoGrupo() {
      if (this.grupoOptions.value === 0) {
        this.$toast.error("Informe um valor para aplicar ao grupo!");
        return;
      }
      if (!this.grupoSelected) {
        this.$toast.error("Informe um grupo!");
        return;
      }

      this.addLoadingToButton("applyPrecoGrupo");
      try {
        this.produtosGrupo = await this.fetchProdutosGrupo(
          this.grupoSelected.id,
          this.grupoOptions.value,
          this.grupoOptions.fator
        );
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("applyPrecoGrupo");
    },
    async addProduto() {
      if (_.isEmpty(this.produtoSelected)) return;
      this.produtos = [...this.produtos, { ...this.produtoSelected }];

      this.produtoSelected = {
        descricao: "",
        id_produto: null,
        preco_lista: 0,
      };

      this.keyToRender = this.keyToRender + 1;
    },
  },
  watch: {
    lista(value) {
      if (value) {
        if (this.lista.id_lista_preco) {
          const { status, descricao, produtos, aplicar_sem_cliente } =
            this.lista;
          this.form.status = status;
          this.form.descricao = descricao;
          this.form.aplicar_sem_cliente = aplicar_sem_cliente;
          this.produtos = produtos.map((produto) => ({
            ...produto,
            preco_lista: produto.pivot.preco_lista,
          }));
        }
      }
    },
  },
};
